import styled from 'styled-components';

import { BLACK, WHITE } from '@/styles/variables.style';
import media from '@/styles/media.style';

export const Wrapper = styled.div`
  margin: 0;
`;

export const ResultCopySection = styled.section`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin: 40px auto 60px;
  padding: 0 20px;

  ${media.tabletL`
    margin: 100px auto 120px;
  `};

  ${media.desktopMedium`
    width: 1050px;
    margin: 100px auto 120px;
  `};
`;

export const ResultCopyContainer = styled.div`
  width: 100%;
  padding: 40px 20px;
  background: ${({ background }) => background};
  text-align: center;

  ${media.tabletL`
     padding: 80px 40px;
  `};
`;

export const MarkdownStyle = styled.div`
  color: ${BLACK};

  p {
    margin-bottom: 14px;
    font-size: 14px;
    line-height: 16px;
    text-align: center;

    ${media.tabletL`
      margin-bottom: 20px;
      font-size: 18px;
      line-height: 20px;
    `};
  }

  h3 {
    margin-bottom: 20px;
    font-size: 20px;
    line-height: 22px;

    ${media.tabletL`
      margin-bottom: 40px;
      font-size: 30px;
      line-height: 32px;
    `};
  }

  h5 {
    margin-bottom: 40px;
    font-size: 14px;
    line-height: 16px;

    ${media.tabletL`
      margin-bottom: 60px
      font-size: 22px;
      line-height: 24px;
    `};
  }
`;

export const ResultSection = styled.section`
  margin-bottom: 80px;

  ${media.desktopMedium`
    width: 1053px;
    margin: 100px auto 120px;
  `};
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 0;
`;

export const SalonLocatorLinkSection = styled.section`
  margin-bottom: 60px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  > :first-child {
    margin-right: 0;
    margin-bottom: 40px;
  }

  ${media.tabletL`
    margin-bottom: 80px;
    display: flex;
    flex-direction: row;

    > :first-child {
      margin-right: 40px;
      margin-bottom: 0;
    }
  `};
`;

export const Button = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 220px;
  height: 48px;
  font-size: 12px;
  line-height: 14px;
  letter-spacing: 2px;
  text-transform: uppercase;
  background: ${BLACK};
  color: ${WHITE};
  cursor: pointer;

  ${media.tabletL`
    width: 338px;
    height: 72px;
    font-size: 14px;
    line-height: 16px;
  `};
`;

export const SnsLinksSection = styled.section`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-bottom: 110px;

  ${media.tabletL`
    margin-bottom: 120px;
  `};
`;

export const SnsLink = styled.div`
  min-width: 90px;
  text-align: center;

  &.fbIcon {
    padding-right: 40px;
  }

  &.twIcon {
    padding-left: 40px;
  }
`;

export const IconWrapper = styled.div`
  width: 100%;
`;

export const SnsLinkWrapper = styled.div`
  width: 100%;
  margin-top: 10px;
`;

export const Linker = styled.a`
  color: ${BLACK};
  font-size: 14px;
  line-height: 16px;
  text-decoration: underline;
`;

export const Icon = styled.img`
  width: 50px;
  height: 50px;
`;



// WEBPACK FOOTER //
// ./src/pages/HairDiagnosis/HairDiagnosisResultPage/HairDiagnosisResultPage.style.js